import PostDetails from "./PostDetails";

import Login from "./Login";
import Admin from "./Admin";
import AdminRoute from "./components/AdminRoute";
import PublicPageReveal from "./components/PublicPageReveal";
import PageSEO from "./components/PageSEO";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import JoinCircle from "./pages/JoinCircle";
import MostRead from "./pages/MostRead";
import VerifyEmail from "./pages/VerifyEmail";
import WriterPage from "./WriterPage";
import Footer from "./components/Footer";

import React, {
  useEffect,
  useRef,
  useState
} from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
  Navigate
} from "react-router-dom";
import "./App.css";

import Publications from "./pages/Publications";

import Books from "./pages/Books";
import Newspapers from "./pages/Newspapers";
import Magazines from "./pages/Magazines";

import News from "./pages/News";

import State from "./pages/State";
import National from "./pages/National";
import Organisational from "./pages/Organisational";
import PressRelease from "./pages/PressRelease";

import PhotosVideos from "./pages/PhotosVideos";
import Photos from "./pages/Photos";
import Videos from "./pages/Videos";
import ChatraSanglap from "./pages/ChatraSanglap";

import Articles from "./pages/Articles";

import International from "./pages/International";
import NationalArticle from "./pages/NationalArticle";
import StateArticle from "./pages/StateArticle";
import Sports from "./pages/Sports";
import Science from "./pages/Science";
import InkAndEcho from "./pages/InkAndEcho";
import Environment from "./pages/Environment";
import HerSpace from "./pages/HerSpace";
import TribalVoices from "./pages/TribalVoices";

import InkAndEchoStories from "./pages/InkAndEchoStories";
import InkAndEchoPoems from "./pages/InkAndEchoPoems";
import InkAndEchoArticles from "./pages/InkAndEchoArticles";

import Editorial from "./pages/Editorial";
import CampusReport from "./pages/CampusReport";

import BackToTopButton from "./components/BackToTopButton";

import {
  API_URL
} from "./config/api";

function App() {
const [posts, setPosts] = useState([]);
const [publications, setPublications] = useState([]);
const [homeLoading, setHomeLoading] = useState(true);

const [
  isNavMenuOpen,
  setIsNavMenuOpen
] = useState(false);

const navMenuRef =
  useRef(null);

const navMenuToggleRef =
  useRef(null);

const handleSamePageNavClick = (event) => {

  /*
   * Preserve normal browser behaviour for:
   * Ctrl/Cmd-click, Shift-click, Alt-click,
   * and non-left mouse clicks.
   */
  if (
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  ) {
    return;
  }

  const link =
    event.target.closest?.("a");

  if (!link) {
    return;
  }

  const targetUrl =
    new URL(
      link.href,
      window.location.href
    );

  /*
   * Only handle links belonging to
   * this website.
   */
  if (
    targetUrl.origin !==
    window.location.origin
  ) {
    return;
  }

  const currentUrl =
    new URL(window.location.href);

  /*
   * Reload only when the destination
   * is exactly the page already open.
   *
   * Search parameters and hash are
   * deliberately included so that a
   * future link such as:
   *
   * /articles?sort=latest
   * /articles#section
   *
   * is still allowed to navigate
   * normally.
   */
  const isExactSamePage =
    targetUrl.pathname ===
      currentUrl.pathname &&
    targetUrl.search ===
      currentUrl.search &&
    targetUrl.hash ===
      currentUrl.hash;

  if (!isExactSamePage) {
    return;
  }

  event.preventDefault();

  window.location.reload();

};

const handleNavMenuContentClick =
  (event) => {

    const link =
      event.target.closest?.("a");

    if (link) {
      setIsNavMenuOpen(false);
    }

  };


useEffect(() => {

  if (!isNavMenuOpen) {
    return undefined;
  }


  const handlePointerDown =
    (event) => {

      if (
        navMenuRef.current &&
        !navMenuRef.current.contains(
          event.target
        )
      ) {

        setIsNavMenuOpen(false);

      }

    };


  const handleKeyDown =
    (event) => {

      if (event.key !== "Escape") {
        return;
      }


      setIsNavMenuOpen(false);

      navMenuToggleRef.current
        ?.focus();

    };


  document.addEventListener(
    "pointerdown",
    handlePointerDown
  );

  document.addEventListener(
    "keydown",
    handleKeyDown
  );


  return () => {

    document.removeEventListener(
      "pointerdown",
      handlePointerDown
    );

    document.removeEventListener(
      "keydown",
      handleKeyDown
    );

  };

}, [isNavMenuOpen]);

useEffect(() => {

  const mediaQuery =
    window.matchMedia(
      "(max-width: 950px)"
    );


  const handleNavigationModeChange =
    () => {

      setIsNavMenuOpen(false);

    };


  mediaQuery.addEventListener(
    "change",
    handleNavigationModeChange
  );


  return () => {

    mediaQuery.removeEventListener(
      "change",
      handleNavigationModeChange
    );

  };

}, []);

  useEffect(() => {

    const fetchPosts = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/posts`
        );

        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };


    const fetchPublications = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/api/publications`
        );

        setPublications(res.data);
      } catch (err) {
        console.log(err);
      }
    };


    // Initial homepage fetch
    Promise.allSettled([
      fetchPosts(),
      fetchPublications()
    ]).finally(() => {
      setHomeLoading(false);
    });


    // Listen for publication uploads/changes
    const handlePublicationsUpdated = () => {
      fetchPublications();
    };

    window.addEventListener(
      "publicationsUpdated",
      handlePublicationsUpdated
    );


    // Listen for post uploads/changes
    const handlePostsUpdated = () => {
      fetchPosts();
    };

    window.addEventListener(
      "postsUpdated",
      handlePostsUpdated
    );


    // Cleanup
    return () => {

      window.removeEventListener(
        "publicationsUpdated",
        handlePublicationsUpdated
      );

      window.removeEventListener(
        "postsUpdated",
        handlePostsUpdated
      );

    };

  }, []);

    return (
    <Router>
  <div>
    <PageSEO />
    <PublicPageReveal />
    <BackToTopButton />

        <header className="navbar">

  <div className="masthead-logo-panel">

    <img
      src="/logo.png"
      alt="ছাত্র সংবাদ logo"
      className="site-logo"
    />

  </div>


  <div className="masthead-right">

    <nav
      ref={navMenuRef}
      className={
        isNavMenuOpen
          ? "masthead-nav nav-menu-open"
          : "masthead-nav"
      }
      onClickCapture={
        handleSamePageNavClick
      }
      aria-label="Main navigation"
    >

      <div
        id="site-navigation-menu"
        className="nav-menu-content"
        onClick={
          handleNavMenuContentClick
        }
      >

        <ul
          className="
            nav-links
            nav-primary-links
          "
        >

          <li>

            <NavLink
              to="/"
              end
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Home
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/editorial"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Editorial
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/articles"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Articles
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/news"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              News
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/campus-report"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Campus Report
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/photos-videos"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Media
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/publications"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Publications
            </NavLink>

          </li>

        </ul>


        <ul
          className="
            nav-links
            nav-secondary-links
          "
        >

          <li>

            <NavLink
              to="/most-read"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Most Read
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/join"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              Join the Circle
            </NavLink>

          </li>


          <li>

            <NavLink
              to="/about-us"
              className={({
                isActive
              }) =>
                isActive
                  ? "nav-link active-nav-link"
                  : "nav-link"
              }
            >
              About Us
            </NavLink>

          </li>

        </ul>

      </div>


      <button
        ref={navMenuToggleRef}
        type="button"
        className="nav-menu-toggle"
        aria-label={
          isNavMenuOpen
            ? "Close navigation menu"
            : "Open navigation menu"
        }
        aria-expanded={
          isNavMenuOpen
        }
        aria-controls=
          "site-navigation-menu"
        onClick={() =>
          setIsNavMenuOpen(
            current =>
              !current
          )
        }
      >

        <span />
        <span />
        <span />

      </button>

    </nav>

  </div>

</header>

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            }
          />

          <Route
            path="/post/:id"
            element={
              <PostDetails
                posts={posts}
                allPosts={posts}
              />
            }
          />

          <Route
            path="/"
            element={
              <Home
                posts={posts}
                publications={publications}
                isLoading={homeLoading}
              />
            }
          />
          <Route
            path="/editorial"
            element={
              <Editorial
                posts={posts}
                publications={publications}
              />
            }
          />
          <Route
            path="/articles"
            element={<Articles posts={posts} />}
/>
          <Route
            path="/news"
            element={<News posts={posts} />}
          />
          <Route
            path="/campus-report"
            element={
              <CampusReport
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/photos-videos"
            element={<PhotosVideos />}
          />

          <Route
            path="/photos-videos/photos"
            element={
              <Photos
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/photos-videos/videos"
            element={
              <Videos
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
  path="/photos-videos/chatra-sanglap"
  element={
    <ChatraSanglap
      posts={posts}
      publications={publications}
    />
  }
/>

          <Route
            path="/publications"
            element={
              <Publications
                posts={posts}
                publications={publications}
              />
            }
          />
          <Route
            path="/publications/books"
            element={
              <Books
                posts={posts}
                publications={publications}
              />
            }
          />
          <Route
            path="/publications/newspapers"
            element={
              <Newspapers
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/publications/magazines"
            element={
              <Magazines
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
  path="/join"
  element={<JoinCircle />}
/>

<Route
  path="/most-read"
  element={<MostRead />}
/>

<Route
  path="/verify-email"
  element={<VerifyEmail />}
/>

<Route
  path="/about-us"
  element={<AboutUs />}
/>

          <Route
            path="/news/state"
            element={
              <State
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/news/national"
            element={
              <National
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/news/organisational"
            element={
              <Organisational
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/news/press-release"
            element={
              <PressRelease
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/international"
            element={
              <International
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/national"
            element={
              <NationalArticle
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/state"
            element={
              <StateArticle
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/sports"
            element={
              <Sports
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/science"
            element={
              <Science
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
  path="/articles/ink-and-echo"
  element={
    <InkAndEcho
      posts={posts}
      publications={publications}
    />
  }
/>

<Route
  path="/articles/ink-and-echo/stories"
  element={
    <InkAndEchoStories
      posts={posts}
      publications={publications}
    />
  }
/>

<Route
  path="/articles/ink-and-echo/poems"
  element={
    <InkAndEchoPoems
      posts={posts}
      publications={publications}
    />
  }
/>

<Route
  path="/articles/ink-and-echo/articles"
  element={
    <InkAndEchoArticles
      posts={posts}
      publications={publications}
    />
  }
/>

<Route
  path="/articles/cultural"
  element={
    <Navigate
      to="/articles/ink-and-echo"
      replace
    />
  }
/>

          <Route
            path="/articles/environment"
            element={
              <Environment
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/her-space"
            element={
              <HerSpace
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
            path="/articles/tribal-voices"
            element={
              <TribalVoices
                posts={posts}
                publications={publications}
              />
            }
          />

          <Route
              path="/writer/:writerName"
              element={<WriterPage />}
          />
                </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
